const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoltInMarkerBackground(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x30_1.charging",
    enableBackground: "new 0 0 195 195",
    height: 512,
    viewBox: "0 0 195 195",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "matrix(1.282262,0,0,1.282262,-27.456609,-27.56863)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000",
      strokeWidth: 0.297021,
      fillOpacity: 0.5
    },
    id: "path988",
    cx: 95.852325,
    cy: 80.90136,
    r: 53.463867
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 97.5,21.5 c -33.3,0 -60.3,27 -60.3,60.3 0,8.6 1.8,16.7 5,24.1 0.1,0.3 0.3,0.6 0.4,0.9 0.3,0.7 0.7,1.5 1.1,2.2 0.2,0.3 0.3,0.6 0.5,1 0.4,0.8 0.9,1.7 1.4,2.5 0.1,0.1 0.1,0.2 0.2,0.4 2.5,4.2 5.6,8.1 9,11.5 l 35.7,45.8 c 3.5,4.5 10.3,4.5 13.8,0 L 140,124.5 c 3.5,-3.5 6.5,-7.4 9.1,-11.6 5.5,-9.1 8.6,-19.7 8.6,-31 0.1,-33.4 -26.9,-60.4 -60.2,-60.4 z m 0,110.3 c -27.6,0 -50,-22.4 -50,-50 0,-27.6 22.4,-50 50,-50 27.6,0 50,22.4 50,50 0,27.6 -22.4,50 -50,50 z",
    style: {
      display: "inline",
      fill: "#000000"
    },
    id: "path824"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 99.3,74.5 c 0,-10.9 0,-21.7 0,-32.6 v -0.1 l -0.1,0.1 C 90.8,57.6 82.3,73.3 73.9,89 h 21.8 v 32.5 0.2 l 0.1,-0.2 c 8.4,-15.7 16.9,-31.4 25.4,-47.1 -7.4,0.1 -14.6,0.1 -21.9,0.1 z",
    style: {
      fill: "#f6d04d"
    },
    id: "path826"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoltInMarkerBackground);
export default __webpack_public_path__ + "static/media/boltInMarkerBackground.5c178d045f9b7303600a9c2d23471fe3.svg";
export { ForwardRef as ReactComponent };